export default __webpack_public_path__ + "static/media/assign-a-photograapher.f0a1ebc5.webp";